import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { ContactWorkflowStatus } from 'clickNgo/entities/contact'
import { IContact } from 'clickNgo/entities/contact'
import { CrudStore } from 'core/types/crudStore'

import { map375FromContact } from './mapping/map375FromContact'
import { map379FromContact } from './mapping/map379FromContact'

interface IUpdateContact {
  contact: IContact
  sourceRequester: string
  source?: string
  workflowStatus?: ContactWorkflowStatus
}

// TODO: Update type and values for workflowStatus
export const updateContact = async ({
  contact,
  source = ProfilingRequestSource.ClickAndGo,
  sourceRequester,
  workflowStatus,
}: IUpdateContact) => {
  const contactCopy = { ...contact }
  const contactExtOptions = { formId: '375', code: 'ContactExt' }
  const contactAdditionalOptions = { formId: '379', code: 'ContactAdditionalInfo' }
  const isNewContact = contactCopy.contactId.startsWith('new-')
  const hasModifiedData = Boolean(contactCopy.modifiedValues.length)
  const isExtModified = isNewContact || hasModifiedData
  const profileWorkflowStatus = contactCopy.workflowStatus || ContactWorkflowStatus.New
  const newWorkflowStatus: ContactWorkflowStatus = isExtModified
    ? workflowStatus || ContactWorkflowStatus.New
    : workflowStatus || profileWorkflowStatus
  const isRejected = newWorkflowStatus === 'Rejected'
  const isDone = newWorkflowStatus === 'Done'
  const crud = CrudStore.get(isNewContact ? CrudStoreItem.ContactExt : CrudStoreItem.ContactAllData)

  contactCopy.workflowStatus = newWorkflowStatus
  contactCopy.sourceRequester = sourceRequester
  contactCopy.source = source

  if (hasModifiedData) {
    if (isRejected) {
      if (contact.entryId) {
        await crud.update(contactExtOptions, [{ EntryId: contactCopy.entryId }])
      } else {
        await crud.delete(contactExtOptions, [{ EntryId: contactCopy.entryId }], 'EntryId')
      }
    }
    if (isDone) {
      if (contact.entryId) {
        await crud.update(contactExtOptions, [
          { EntryId: contactCopy.entryId, LastRequest: 'false' },
        ])
        contactCopy.entryId = undefined
      }
    }

    const data = map375FromContact(contactCopy)
    const result = await crud[data.EntryId ? 'update' : 'create'](contactExtOptions, [data])

    if (result) {
      contactCopy.entryId375 = result[0].EntryId
      contactCopy.workflowStatus = result[0].WorkflowStatus
      contactCopy.modified = result[0].Modified
    }

    if (!isNewContact) {
      const contactAdditional = map379FromContact(contactCopy)
      const result = await crud[contactAdditional.EntryId ? 'update' : 'create'](
        contactAdditionalOptions,
        [contactAdditional]
      )
      contactCopy.entryId379 = result[0].EntryId
      contactCopy.modified = result[0].Modified
    }
  }

  return contactCopy
}
